import API from 'app/utils/apiClient';

const socialSignin = (social, accessToken, idToken) =>
  API.post('/sign/providers/social/in/', {
    social,
    accessToken,
    ...(idToken ? { idToken } : {}),
  });

const socialSignup = ({
  social,
  accessToken,
  idToken = null,
  nickname,
  birthday = null,
  gender = null,
}) =>
  API.post('/sign/providers/social/up/', {
    social,
    accessToken,
    ...(idToken ? { idToken } : {}),
    nickname,
    ...(birthday ? { birthday } : {}),
    ...(gender ? { gender } : {}),
  });

const emailSignup = ({
  email,
  password,
  nickname,
  birthday = null,
  gender = null,
}) =>
  API.post('/sign/providers/email/up/', {
    email,
    password,
    nickname,
    ...(birthday ? { birthday } : {}),
    ...(gender ? { gender } : {}),
  });

const recoveryUser = (value) => API.post('/sign/recovery/', { value });

const recoveryUserByPhone = (transactionId) =>
  API.post('/sign/recovery-by-certification/', { transactionId });

const sendResetPassword = (value) =>
  API.post('/sign/password-reset/', { value });

const checkSign = (key, value) => API.post('/sign/check/', { key, value });

const signOut = () => API.post('/sign/out/');

export default {
  socialSignin,
  socialSignup,
  emailSignup,
  recoveryUser,
  recoveryUserByPhone,
  sendResetPassword,
  checkSign,
  signOut,
};



// WEBPACK FOOTER //
// ./src/app/apis/sign.js